import WebFooter from "../../../components/website/webFooter/WebFooter";
import WebHeader from "../../../components/website/webHeader/WebHeader";

export default function Contact() {
  return (
    <>
      <WebHeader />
      <div className="page active" id="page-contact">
        <section className="page-hero">
          <div className="hero-bg" />
          <div className="wrap">
            <span className="eyebrow">
              <span className="dot" />
              Contact
            </span>
            <h1>Let's talk.</h1>
            <p>
              Whether you want a demo, a migration from your current software,
              or just have a tricky edge case — we're reachable and we respond
              fast.
            </p>
          </div>
        </section>
        <section>
          <div className="wrap contact-grid">
            <div className="contact-info">
              <div className="contact-card">
                <div className="ic">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <h4>Email</h4>
                <p>For sales, support, or anything else.</p>
                <p style={{ marginTop: 8 }}>
                  <a href="mailto:inquiry@myrentmitra.com">
                    inquiry@myrentmitra.com
                  </a>
                </p>
              </div>
              <div className="contact-card">
                <div
                  className="ic"
                  style={{
                    background: "var(--blue-light)",
                    color: "var(--blue)",
                  }}
                >
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <h4>Phone</h4>
                <p>Mon–Sat · 9:00 AM – 9:00 PM IST</p>
                <p style={{ marginTop: 8 }}>
                  <a href="tel:+917016853661">+91 7016853661</a>
                </p>
                <p
                  style={{ color: "var(--ink-3)", fontSize: 12, marginTop: 4 }}
                >
                  Urgent? Drop a voice note — we respond in under 20 minutes.
                </p>
              </div>
              <div className="contact-card">
                <div
                  className="ic"
                  style={{
                    background: "var(--amber-light)",
                    color: "var(--amber)",
                  }}
                >
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                </div>
                <h4>Office</h4>
                <p>
                  Kashishindia Private Limited
                  <br />
                  F02-007, EMAAR THE PALM SQUARE, Sector 66,
                  <br />
                  Gurugram Haryana - 122102
                </p>
              </div>
            </div>
            <div className="contact-form">
              <h2>Tell us about yourself</h2>
              <p className="sub">
                Fill this out and we'll get back to you within 4 working hours.
              </p>
              <div className="form-row">
                <div className="form-field">
                  <label>First name</label>
                  <input type="text" placeholder="Rohit" />
                </div>
                <div className="form-field">
                  <label>Last name</label>
                  <input type="text" placeholder="Venkatesh" />
                </div>
              </div>
              <div className="form-field">
                <label>Work email</label>
                <input type="email" placeholder="rohit@urbannest.in" />
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Phone</label>
                  <input type="tel" placeholder="+91 98XXXXXXXX" />
                </div>
                <div className="form-field">
                  <label>Role</label>
                  <select>
                    <option>Property / PG Owner</option>
                    <option>Operations Manager</option>
                    <option>Landlord (rental flats)</option>
                    <option>Real Estate Operator</option>
                    <option>Other</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Number of beds</label>
                  <select>
                    <option>Under 30</option>
                    <option>30–100</option>
                    <option>100–250</option>
                    <option>250–500</option>
                    <option>500+</option>
                  </select>
                </div>
                <div className="form-field">
                  <label>I'm interested in</label>
                  <select>
                    <option>Starting a free trial</option>
                    <option>Booking a demo</option>
                    <option>Migration from another tool</option>
                    <option>Pro plan / enterprise</option>
                    <option>Partnership</option>
                  </select>
                </div>
              </div>
              <div className="form-field">
                <label>Tell us more (optional)</label>
                <textarea
                  placeholder="What are you trying to solve? What tools are you using today?"
                  defaultValue={""}
                />
              </div>
              <button
                className="btn btn-primary"
                type="button"
                onclick="alert('Thanks! We will get back within 4 hours.')"
              >
                Send message
                <svg
                  className="arrow"
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </button>
              <p
                style={{
                  fontSize: 11,
                  color: "var(--ink-3)",
                  marginTop: 16,
                  textAlign: "center",
                }}
              >
                By submitting, you agree to our{" "}
                <a
                  href="#"
                  style={{ color: "var(--ink-2)", textDecoration: "underline" }}
                >
                  Privacy Policy
                </a>
                . We'll never spam you or share your email.
              </p>
            </div>
          </div>
        </section>
      </div>

      <WebFooter />
    </>
  );
}
